import "./App.css";
import Header from "./layouts/Header/index";
import Main from "./pages/Main/index";
import FormBooking from "./pages/FormBooking/index";
import CheckBooking from "./pages/CheckBooking/index";
import { Routes, Route } from "react-router-dom";
import TermAndConditions from "./pages/TermAndConditions";
import ScrollToTop from "./utils/ScrollToTop";
import BookingSummary from "./pages/BookingSummary";
import Payment from "./pages/Payment";
import { NotFoundPage } from "./pages/NotFoundPage/NotFoundPage";
import Footer from "./layouts/Footer";
import ImageCarousel from "./components/ImageCarousel";
import CityShuttleFormBooking from "./pages/ShuttleFormBooking";
import ShuttleBookingSummary from "./pages/ShuttleBookingSummary";
import HotelList from "./pages/HotelList";

function App() {
  if (process.env.REACT_APP_STATUS === "PRODUCTIONS") {
    console.log = function () {};
  }
  return (
    <div>
      <div className="flex flex-col min-w-full min-h-screen justify-between">
        <ImageCarousel />
        <Header />
        <ScrollToTop />
        <div className=" flex flex-auto justify-center mb-[85px]">
          <Routes>
            <Route path="/" element={<Main />} />
            <Route path="FormBooking/:carId/:type" element={<FormBooking />} />
            <Route
              path="FormBooking/CityShuttle"
              element={<CityShuttleFormBooking />}
            />
            <Route path="CheckBooking/" element={<CheckBooking />} />
            <Route path="TermAndConditions/" element={<TermAndConditions />} />
            <Route
              path="BookingSummary/:emailAddress/:bookingID"
              element={<BookingSummary />}
            ></Route>
            <Route path="BookingSummary/" element={<BookingSummary />} />
            <Route
              path="BookingSummary/CityShuttle"
              element={<ShuttleBookingSummary />}
            />
            <Route path="Payment/" element={<Payment />} />
            <Route path="*" element={<NotFoundPage />} />
            <Route path="HotelList/" element={<HotelList />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}

export default App;
